module.exports = __webpack_public_path__ + "static/assets/703b25887f5775c8449ceb8949f0bf44.png";